export default Alpine.data('dashboardViewGoogleMap', (tasks, defaultAddress) => {
    return {
        search: '',
        markers: [],
        tasks: tasks,
        defaultAddress: defaultAddress,
        currentInfoWindow: null,
        handleTasksUpdated(event) {
            console.log('Tasks updated');

            this.tasks = event.detail.tasks;

            this.addMarkers();
            this.centerMap();
        },
        async bootMap() {
            var center = { lat: 0, lng: 0 };

            if (this.tasks.length !== 0) {
                center = {
                    lat: this.tasks[0].lat,
                    lng: this.tasks[0].lng
                };
            } else if (this.defaultAddress !== null) {
                // Center map on shelter's default campus address if no pins present
                await google.maps.importLibrary("geocoding");

                const geocoder = new google.maps.Geocoder();
                const geocodeResp = await geocoder.geocode({
                    address: this.defaultAddress
                });

                if (geocodeResp.results.length > 0) {
                    center = geocodeResp.results[0].geometry.location;
                }
            }

            window.initMap('map', center);

            await this.addMarkers();

            await this.bootAutocomplete();

            const autocompleteField = document.querySelector('gmp-place-autocomplete').ui.shadowRoot.querySelector('input');
            autocompleteField.type = 'search';
            autocompleteField.placeholder = 'Search for a location...';
        },
        async bootAutocomplete() {
            await google.maps.importLibrary("places");

            const placeAutocomplete = new google.maps.places.PlaceAutocompleteElement({id: 'autocomplete-input'});

            document.getElementById('autocomplete').appendChild(placeAutocomplete);

            const selectedPlaceTitle = document.createElement('p');
            selectedPlaceTitle.textContent = '';
            document.getElementById('autocomplete').appendChild(selectedPlaceTitle);
            const selectedPlaceInfo = document.createElement('pre');
            selectedPlaceInfo.textContent = '';
            document.getElementById('autocomplete').appendChild(selectedPlaceInfo);

            placeAutocomplete.addEventListener('gmp-select', async ({ placePrediction }) => {
                const place = placePrediction.toPlace();
                await place.fetchFields({ fields: ['displayName', 'formattedAddress', 'location'] });

                const position = {
                    lat: place.location.lat(),
                    lng: place.location.lng()
                };
                window.map.setCenter(position);
            });
        },
        centerMap() {
            const center = {
                lat: this.tasks[0].lat,
                lng: this.tasks[0].lng
            };

            window.map.setCenter(center);
        },
        async addMarker(position, task) {
            const { InfoWindow } = await google.maps.importLibrary("maps");
            const { AdvancedMarkerElement } = await google.maps.importLibrary("marker")

            const infoWindow = new InfoWindow();

            const parser = new DOMParser();
            const pinSvgString = await this.pinSvgString(task.priority);
            const pinSvg = parser.parseFromString(pinSvgString, "image/svg+xml").documentElement;

            const infoMarker = new AdvancedMarkerElement({
                map: window.map,
                position: position,
                content: pinSvg,
            });

            infoMarker.addListener("gmp-click", (event) => {
                this.currentInfoWindow?.close();

                infoWindow.setContent(this.infoWindowContent(task));

                infoWindow.open(infoMarker.map, infoMarker);
                this.currentInfoWindow = infoWindow;
            });

            this.markers.push(infoMarker);
        },
        async addMarkers() {
            this.deleteMarkers();

            this.tasks.forEach((task) => {
                const position = {
                    lat: task.lat,
                    lng: task.lng
                };

                this.addMarker(position, task);
            });
        },
        deleteMarkers() {
            this.markers.forEach((marker) => {
                marker.setMap(null);
            });
            this.markers = [];
        },
        pinSvgString(priortyLevel) {
            const pinSvgMap = {
                'P1': '/svg/field-services/p1-pin.svg',
                'P2': '/svg/field-services/p2-pin.svg',
                'P3': '/svg/field-services/p3-pin.svg',
                'P4': '/svg/field-services/p4-pin.svg',
                'P5': '/svg/field-services/p5-pin.svg',
                'p-none': '/svg/field-services/p-none-pin.svg',
            };

            const pinSvgUrl = pinSvgMap[priortyLevel] || pinSvgMap['p-none'];

            return fetch(pinSvgUrl).then(response => response.text());
        },
        priorityColor(priority) {
            const priorityColorMap = {
                'P1': 'bg-priority1 text-white',
                'P2': 'bg-priority2',
                'P3': 'bg-priority3',
                'P4': 'bg-priority4',
                'P5': 'bg-priority5',
                'p-none': 'hidden',
            };
            return priorityColorMap[priority] || priorityColorMap['p-none'];
        },
        infoWindowContent(task) {
            const locationOutlineSvg = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.00004 1.33334C5.42004 1.33334 3.33337 3.42 3.33337 6C3.33337 9.5 8.00004 14.6667 8.00004 14.6667C8.00004 14.6667 12.6667 9.5 12.6667 6C12.6667 3.42 10.58 1.33334 8.00004 1.33334ZM4.66671 6C4.66671 4.16 6.16004 2.66667 8.00004 2.66667C9.84004 2.66667 11.3334 4.16 11.3334 6C11.3334 7.92 9.41337 10.7933 8.00004 12.5867C6.61337 10.8067 4.66671 7.9 4.66671 6Z" fill="#333333"/>
<path d="M8.00004 7.66667C8.92052 7.66667 9.66671 6.92048 9.66671 6C9.66671 5.07953 8.92052 4.33334 8.00004 4.33334C7.07957 4.33334 6.33337 5.07953 6.33337 6C6.33337 6.92048 7.07957 7.66667 8.00004 7.66667Z" fill="#333333"/>
</svg>
`;

            const personOutlineSvg = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.99996 3.93333C8.18381 3.93333 8.36586 3.96954 8.53572 4.0399C8.70557 4.11026 8.85991 4.21338 8.98991 4.34338C9.11991 4.47338 9.22303 4.62772 9.29339 4.79757C9.36375 4.96743 9.39996 5.14948 9.39996 5.33333C9.39996 5.51718 9.36375 5.69923 9.29339 5.86909C9.22303 6.03894 9.11991 6.19328 8.98991 6.32328C8.85991 6.45328 8.70557 6.55641 8.53572 6.62676C8.36586 6.69712 8.18381 6.73333 7.99996 6.73333C7.62866 6.73333 7.27256 6.58583 7.01001 6.32328C6.74746 6.06073 6.59996 5.70463 6.59996 5.33333C6.59996 4.96203 6.74746 4.60593 7.01001 4.34338C7.27256 4.08083 7.62866 3.93333 7.99996 3.93333ZM7.99996 9.93333C9.97996 9.93333 12.0666 10.9067 12.0666 11.3333V12.0667H3.93329V11.3333C3.93329 10.9067 6.01996 9.93333 7.99996 9.93333ZM7.99996 2.66666C6.52663 2.66666 5.33329 3.86 5.33329 5.33333C5.33329 6.80666 6.52663 8 7.99996 8C9.47329 8 10.6666 6.80666 10.6666 5.33333C10.6666 3.86 9.47329 2.66666 7.99996 2.66666ZM7.99996 8.66666C6.21996 8.66666 2.66663 9.56 2.66663 11.3333V12.6667C2.66663 13.0333 2.96663 13.3333 3.33329 13.3333H12.6666C13.0333 13.3333 13.3333 13.0333 13.3333 12.6667V11.3333C13.3333 9.56 9.77996 8.66666 7.99996 8.66666Z" fill="#333333"/>
</svg>
`;

            const calendarOutlineSvg = `<svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
</svg>
`;
            const overdueStyle = task.is_overdue ? 'text-error' : '';

            return `<div>
                        <div>
                            <div
                                class="border inline-flex rounded-full text-sm font-semibold text-gray-800 text-center whitespace-nowrap gap-1 items-center mt-px px-2.5 py-0.5 mr-2 ${this.priorityColor(task.priority)}"
                            >
                                ${task.priority}
                            </div>
                            <a class="link-green group link focus-visible:outline-green-600 focus-visible:outline-offset-2 text-md !no-underline" href="${task.url}">${task.title}</a>
                        </div>
                        <div class="ml-6">
                            <div class="mt-2 flex">
                                <span class="mr-2">${locationOutlineSvg}</span> ${task.location}
                            </div>
                            <div class="mt-2 flex">
                                <span class="mr-2">${calendarOutlineSvg}</span> <span class="${overdueStyle}">Due date: ${task.due_at ? task.due_at : 'No due date'}</span>
                            </div>
                            <div class="mt-2 text-gray-700 text-xs flex">
                                <span class="mr-2">${personOutlineSvg}</span> ${task.assigned_user ? task.assigned_user : 'Unassigned'}
                            </div>
                        </div>
                </div>
            `;
        },
    }
});
